// extracted by mini-css-extract-plugin
module.exports = {"userContainer":"styles-module__userContainer___1qMoK","avatarIconContainer":"styles-module__avatarIconContainer___2GpNk"};